module.exports = __webpack_public_path__ + "static/media/session-card-bg.d04d8738.png";